import { Component, Input, OnInit, Output, EventEmitter, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnsUtilService } from 'src/app/core/services/uitls/columns-util/columns-util.service';
import { OrderStatus } from 'src/app/models/enums/order-status.enum';
@Component({
  selector: 'ayen-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss'],
})
export class OrderTableComponent implements OnInit {
  @Input() tableData;
  tableHeaderData: any[] = [];
  @Input() checkboxTitle: string = 'رقم الطلب';
  @Input() checkboxKey: string = 'reference_number';
  @Input() pageUrl;
  @Input() openOrderUrl = true;
  @Input() paginationConfig;
  dataTable: any[] = [];
  imgDefault: string = '/assets/images/svg/sort-default.svg';
  imgASC: string = '/assets/images/svg/sort-up.svg';
  imgDesc: string = '/assets/images/svg/sort-down.svg';
  orderingState: Record<string, boolean | null> = {};
  @Output() disabledDelete: any = new EventEmitter();
  @Output() checkedRow: any = new EventEmitter();
  @Output() sortingCol: any = new EventEmitter();
  @Input() boolenObject:{accept:string, notAccept:string} = {accept:'مقبول', notAccept: 'مرفوض'};
  @Input() initialOrdering: string | string[] = [];
  @Input() clickableColumn: string = ''; // Column name that should be clickable
  @Output() columnClicked: EventEmitter<any> = new EventEmitter();
  selectedRowsIndex: any[] = [];
  selectedRowsPK: any[] = [];
  ordering: any[] = [];
  @ViewChildren('elements') elements: QueryList<ElementRef>;

  constructor(private router: Router,
    private columnsUtil: ColumnsUtilService,
    private element: ElementRef,) {}

  ngOnInit(): void {
    this.tableData.subscribe((data) => {
      this.dataTable = data;
      this.element.nativeElement.querySelector('#custom_check_all').checked = false;
    });
   
    this.applyHeaderData();

    if (this.tableHeaderData.some(header => header.value === 'has_refunds')) {
      this.boolenObject = { accept: 'نعم', notAccept: 'لا' };
    }
  }

  applyHeaderData() {
    this.columnsUtil.currentColState.subscribe( data => {
      this.tableHeaderData = data.filter( item => item.visible);
      const statusObj = this.tableHeaderData.find(item => item.value === 'order_status_object');
      if (statusObj && statusObj.visible) {
        this.tableHeaderData = [
          ...this.tableHeaderData.filter(item => item.value !== 'order_status_object'),
          statusObj
        ];
      }

      const initial = this.initialOrdering
        ? (Array.isArray(this.initialOrdering) ? this.initialOrdering : [this.initialOrdering])
        : [];
      this.ordering = [...initial];
      this.tableHeaderData.forEach((header) => {
         if (header.sortable) {
           if (initial.includes(header.value)) {
             this.orderingState[header.value] = false;
           } else if (initial.includes('-' + header.value)) {
             this.orderingState[header.value] = true;
           } else {
             this.orderingState[header.value] = null;
           }
         }
       });
    });
  }

  getSortImg(colName: string) {
    switch (this.orderingState[colName]) {
      case false: return this.imgASC;
      case true: return this.imgDesc;
      default: return this.imgDefault;
    }
  }

  isObject(value) {
    if (typeof value === 'object') {
      return true;
    }
    return false;
  }

  isBoolean(value) {
    return typeof value === 'boolean';
  }

  getStatusClass(status) {
    if (status === null) {
      return 'btn-secondary';
    } else if (status === OrderStatus.Not_Finished) {
      return 'not-finished';
    } else if (status === OrderStatus.New) {
      return 'new';
    } else if (status === OrderStatus.Under_Inspectoring) {
      return 'inspectoring';
    } else if ([OrderStatus.Under_Audit, OrderStatus.Ready_Auditing].includes(status)) {
      return 'audit';
    } else if (status === OrderStatus.Processing) {
      return 'processing';
    } else if (status === OrderStatus.Scheduled) {
      return 'scheduled';
    } else if (
      status === OrderStatus.Delivered ||
      status === OrderStatus.InspectorAssigned
    ) {
      return 'delivered';
    } else if (status === OrderStatus.Completed) {
      return 'completed';
    } else if (
      [OrderStatus.Canceled, OrderStatus.NotPaid, OrderStatus.Auditor_Reject, OrderStatus.Customer_Reject]
      .includes (status)) {
      return 'canceled';
    }
     else if (status === OrderStatus.Holding) {
       return 'holding';
     }
  }

  toggleSorting(colNam: string) {
    this.ordering = [];
    switch (this.orderingState[colNam]) {
      case null:
        this.orderingState[colNam] = false;
        break;

      case false:
        this.orderingState[colNam] = true;
        break;

      case true:
        this.orderingState[colNam] = null;
        break;
    }
    for (const [key, value] of Object.entries(this.orderingState)) {
      switch (value) {
        case false:
          this.ordering.push(key);
          break;
        case true:
          this.ordering.push('-' + key);
          break;
      }
    }
    this.sortingCol.emit({ col: this.ordering });
  }

  selectAll(event) {
    let rowsChecked = [];
    this.disabledDelete.emit(true);
    this.selectedRowsIndex = [];
    this.selectedRowsPK = [];
    const selectInput = this.element.nativeElement.querySelectorAll('input[type="checkbox"]:not(event)');
    selectInput.forEach(input => {
      input.checked =  event.checked;
    });
    rowsChecked = this.element.nativeElement.querySelectorAll('input[type="checkbox"]:not(event)');
    if (event.checked) {
      this.disabledDelete.emit(false);
      for (let row of rowsChecked) {
        let elementId = row.id;
        let index = elementId.slice(0, elementId.indexOf('_'));
        let pk = +elementId.slice(elementId.indexOf('_') + 1);
        this.selectedRowsIndex.push(index);
        if(pk) {
          this.selectedRowsPK.push(pk);
        }
      }
    }
    this.checkedRow.emit({index: this.selectedRowsIndex, id: this.selectedRowsPK});
  }

  deleteSelectRow(event, rowPk, index) {
    this.disabledDelete.emit(true);
    if (event.target.checked) {
      this.selectedRowsIndex.push(index);
      this.selectedRowsPK.push(rowPk);
    } else {
      this.element.nativeElement.querySelector('#custom_check_all').checked = false;
      if (this.selectedRowsIndex.includes(index))
        this.selectedRowsIndex.splice(this.selectedRowsIndex.indexOf(index), 1);
      if (this.selectedRowsPK.includes(rowPk))
        this.selectedRowsPK.splice(this.selectedRowsPK.indexOf(rowPk), 1);
    }
    if (this.selectedRowsPK.length > 0) {
      this.disabledDelete.emit(false);
    }
    this.checkedRow.emit({index: this.selectedRowsIndex, id: this.selectedRowsPK});
  }

  openOrder(id, newTab?) {
    if(this.openOrderUrl) {
      const urlPage = this.pageUrl + id;
        if (newTab) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree([urlPage])
          );
          window.open(url, '_blank');
        } else {
          this.router.navigateByUrl(urlPage);
        }
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  isURL(value: string): boolean {
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (_) {
      return false;
    }
  }

  openNewTab(url: string): void {
    window.open(url, "_blank");
  }

  onColumnClick(event: Event, row: any): void {
    event.stopPropagation();
    this.columnClicked.emit(row);
  }
}
